import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ open, onClose, children, title, panelClassName = '', centered = true }) {
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev || '';
      };
    }
    return undefined;
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  const panelBase = 'relative bg-white w-full max-w-[368px] min-h-[281px] w-full p-6 z-10 rounded-2xl shadow-xl';
  const centerClasses = centered ? 'flex flex-col items-center justify-center' : '';
  const panelClasses = `${panelBase} ${centerClasses} ${panelClassName}`.trim();

  const modal = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div className={`${panelClasses} max-h-full flex flex-col`}>
        {title && <h3 className="text-lg font-semibold mb-4 shrink-0">{title}</h3>}
        <div className="overflow-y-auto w-full">{children}</div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
